<template>
    <Card>
        <Row :gutter="16">
            <Col span="24">
            <div class="global-tool-bar">
                <div class="left-bar">
                    <span class="title">通知公告管理</span>
                </div>
                <div class="right-bar">
                    <Button size="small"
                        class="btns"
                        shape="circle"
                        type="success"
                        icon="ios-add-circle-outline"
                        @click="onNoticeCreate">新增</Button>
                </div>
            </div>
            </Col>
        </Row>

        <Modal v-model="noticeFormShow"
            title="通知公告" :scrollable='true'>

            <Form label-position="top">
                <Row>
                    <FormItem label="标题">
                        <Input v-model="noticeForm.title" :maxlength="100"></Input>
                    </FormItem>
                </Row>
                <Row >
                    <FormItem class="content-top" label="内容">
						<quill-editor v-model="noticeForm.content"></quill-editor>
                    </FormItem>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="success"
                    class="form-button"
                    @click="onSave">保存</Button>
                <Button type="text"
                    class="form-button"
                    @click="onCancel">取消</Button>
            </div>
        </Modal>

        <Row :gutter="16">
            <Col span="24">
            <stand-pagination-table :columns="mainTable.columns"
                :data="mainTable.data"
                :loading="mainTable.loading"
                :table-search="mainTable.tableSearch"
                :table-load-event="getNoticeTableRecords" />
            </Col>
        </Row>
    </Card>
</template>

<script>
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';
import { getNoticeList, saveNotice, deleteNotice } from '@/api/modules/system-management/notice-management';
import { dateTimeRender, dateRender } from '@/libs/tableRowTimeRender';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import { quillEditor } from 'vue-quill-editor';

export default {
    name: 'NoticeList',
    components: {
        StandPaginationTable, quillEditor
    },
    data() {
        return {
            noticeForm: {
                formEditMode: '',
                noticeUuid: '',
                title: '',
                model:'',
                content: ''
            },
            noticeFormShow: false,
            mainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 80, align: 'center' },
                    { title: '标题', key: 'title', align: 'center' },
                    { title: '创建时间', key: 'createTime', align: 'center', render: (h, params) => dateTimeRender(h, params.row.createTime) },
                    { title: '修改时间', key: 'modifyTime', align: 'center', render: (h, params) => dateTimeRender(h, params.row.modifyTime) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style: {},
                                    on: {
                                        click: () => {
                                            this.onNoticeUpdate(params.row);
                                        }
                                    }
                                }, '编辑'),
                                h('Button', {
							    props: {
							        type: 'text',
							        size: 'small'
							    },
							    style: { color:'red' },
							    on: {
							        click: () => {
							            this.onDelete(params.row);
							        }
							    }
                                }, '删除')
                            ]);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getNoticeTableRecords();
    },
    methods: {
        getNoticeTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            this.mainTable.tableSearch.filters.enable = true;
            this.mainTable.tableSearch.filters.conditions.push({ value: '公告', name: 'noticeType', type:'eq' });
            getNoticeList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            }).catch(() => {
                this.mainTable.tableLoading = false;
            });
        },
        onNoticeCreate() {
            this.noticeForm.formEditMode = FORM_EDIT_MODE_CREATE;
            this.noticeForm.noticeUuid = '';
            this.noticeForm.title = '';
            this.noticeForm.content = '';
            this.noticeForm.noticeType = '公告';
            this.noticeFormShow = true;
        },
        onNoticeUpdate(row) {
            this.noticeForm.formEditMode = FORM_EDIT_MODE_MODIFY;
            this.noticeForm.noticeUuid = row.noticeUuid;
            this.noticeForm.title = row.title;
            this.noticeForm.content = row.content;
            this.noticeForm.noticeType = '公告';
            this.noticeFormShow = true;
        },
        onCancel() {
            this.noticeFormShow = false;
        },
        // 删除
        onDelete(row){
            this.$Modal.confirm({
                title: '是否删除该公告？',
                onOk: () => {
                    deleteNotice({ noticeUuid:row.noticeUuid }).then(res => {
                        this.getNoticeTableRecords();
                    });
                }
            });
        },
        onSave() {
            const data = Object.assign({}, this.noticeForm);
            saveNotice(data).then(res => {
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.noticeFormShow = false;
                            this.getNoticeTableRecords();
                        }
                    });
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.form-button {
    margin-top: 5px;
}
.content-top{
	margin-top: 10px;
}
</style>
